// /opt/isp_erp/frontend/src/components/tickets/CloseRetiroDialog.jsx

import React, { useState, useEffect } from 'react';
import MaterialBuscador from './MaterialBuscador';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Typography,
    Box,
    Alert,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid,
    Paper,
    IconButton,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Divider,
    Chip,
    Switch,
    FormControlLabel
} from '@mui/material';
import {
    Warning as WarningIcon,
    Add as AddIcon,
    Delete as DeleteIcon,
    Inventory as InventoryIcon,
    LocationOn as LocationIcon,
    MyLocation as MyLocationIcon,
    PhotoCamera as PhotoIcon,
    Download as DownloadIcon,
    CheckCircle as CheckIcon,
    Vignette as VignetteIcon,
    Delete as DeleteIconVignette
} from '@mui/icons-material';
import { ticketsAPI } from '../../api/tickets.api';
import axios from '../../api/axios';
import FotoUploader from './FotoUploader';
import apiCierre from '../../api/axios';

const CloseRetiroDialog = ({ open, onClose, ticket, onSuccess }) => {
    const [motivoGeneral, setMotivoGeneral] = useState('');
    const [tecnicoId, setTecnicoId] = useState('');
    const [tecnicos, setTecnicos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cargandoTecnicos, setCargandoTecnicos] = useState(false);
    const [error, setError] = useState('');

    // Estados para éxito y PDF
    const [showSuccess, setShowSuccess] = useState(false);
    const [pdfBase64, setPdfBase64] = useState(null);
    const [ticketNumber, setTicketNumber] = useState('');
    const [ticketId, setTicketId] = useState(null);

    // Estados para fotos
    const [fotosBase64, setFotosBase64] = useState([]);

    // Estados para ubicación
    const [ubicacion, setUbicacion] = useState(null);
    const [obteniendoUbicacion, setObteniendoUbicacion] = useState(false);
    const [errorUbicacion, setErrorUbicacion] = useState('');
    const [usarUbicacion, setUsarUbicacion] = useState(true);

    // Estados para múltiples equipos
    const [equiposInstalados, setEquiposInstalados] = useState([]);
    const [equiposARetirar, setEquiposARetirar] = useState([]);
    const [nuevoEquipo, setNuevoEquipo] = useState({ sn: '', motivo: '' });

    // Estados para materiales
    const [materiales, setMateriales] = useState([]);
    // ✅ CAMBIO 1: cantidad como string
    const [nuevoMaterial, setNuevoMaterial] = useState({ material_id: '', cantidad: '1', observaciones: '' });
    const [catalogoMateriales, setCatalogoMateriales] = useState([]);
    const [stockTecnico, setStockTecnico] = useState([]);
    const [cargandoMateriales, setCargandoMateriales] = useState(false);

    // ✅ Estados para viñetas
    const [vinetaRetirar, setVinetaRetirar] = useState(false);
    const [customerVineta, setCustomerVineta] = useState('');

    // ✅ Obtener viñeta del cliente
    useEffect(() => {
        if (ticket && ticket.customer_id) {
            axios.get(`/customers/${ticket.customer_id}`)
                .then(res => {
                    const vineta = res.data?.vineta || '';
                    console.log('🏷️ Viñeta del cliente obtenida:', vineta);
                    setCustomerVineta(vineta);
                })
                .catch(err => console.error('Error obteniendo viñeta del cliente:', err));
        }
    }, [ticket?.customer_id]);

    // Función para descargar PDF
    const handleDownloadPDF = () => {
        if (!pdfBase64) return;

        try {
            const byteCharacters = atob(pdfBase64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `retiro_${ticketNumber || ticketId}.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error descargando PDF:', error);
            setError('Error al descargar el PDF');
        }
    };

    const handleCloseDialog = () => {
        setShowSuccess(false);
        setPdfBase64(null);
        setTicketNumber('');
        setTicketId(null);
        onClose();
    };

    // Función para obtener ubicación
    const obtenerUbicacion = () => {
        if (!navigator.geolocation) {
            setErrorUbicacion('Geolocalización no soportada');
            setUsarUbicacion(false);
            return;
        }

        setObteniendoUbicacion(true);
        setErrorUbicacion('');

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const ubicacionData = {
                    latitud: position.coords.latitude,
                    longitud: position.coords.longitude,
                    precision: position.coords.accuracy
                };
                setUbicacion(ubicacionData);
                setObteniendoUbicacion(false);
            },
            (error) => {
                console.error('Error de geolocalización:', error);
                let mensaje = '';
                switch(error.code) {
                    case error.PERMISSION_DENIED:
                        mensaje = 'Permiso denegado. Activa la ubicación en tu dispositivo.';
                        break;
                    case error.POSITION_UNAVAILABLE:
                        mensaje = 'No se pudo obtener la ubicación. Verifica tu GPS.';
                        break;
                    case error.TIMEOUT:
                        mensaje = 'Tiempo de espera agotado. Intenta nuevamente.';
                        break;
                    default:
                        mensaje = 'Error al obtener ubicación.';
                }
                setErrorUbicacion(mensaje);
                setObteniendoUbicacion(false);
                setUsarUbicacion(false);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
            }
        );
    };

    useEffect(() => {
        if (open) {
            setShowSuccess(false);
            setPdfBase64(null);
            setTicketNumber('');
            cargarTecnicos();
            cargarMateriales();
            cargarEquiposTicket();
            if (ticket?.assigned_technician_id) {
                cargarStockTecnico(ticket.assigned_technician_id);
                setTecnicoId(ticket.assigned_technician_id);
            }
            if (usarUbicacion) {
                obtenerUbicacion();
            }
        }
    }, [open, ticket]);

    const cargarTecnicos = async () => {
        setCargandoTecnicos(true);
        try {
            const data = await ticketsAPI.getTechnicians();
            setTecnicos(data || []);
        } catch (err) {
            console.error('Error cargando técnicos:', err);
        } finally {
            setCargandoTecnicos(false);
        }
    };

    // Si el retiro ya devolvió materiales (fue reabierto), se cargan con su id para corregirlos en vez de reescribirlos
    const cargarCierrePrevio = async () => {
      try {
        const r = await apiCierre.get(`/tickets/${ticket.id}/cierre-previo`);
        const previos = r.data.materiales || [];
        if (previos.length > 0) {
          setMateriales(prev => (prev.length > 0 ? prev : previos.map(m => ({
            material_id: m.material_id, nombre: m.nombre, unidad: m.unidad, cantidad: m.cantidad, observaciones: ''
          }))));
        }
      } catch (e) {
        console.error('No se pudo cargar el cierre previo:', e);
      }
    };

    useEffect(() => {
      if (open && ticket?.id) { cargarCierrePrevio(); }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, ticket?.id]);

    const cargarMateriales = async () => {
        try {
            const response = { data: [] }; // el buscador consulta al servidor: ya no se descarga el catálogo completo
            setCatalogoMateriales(response.data || []);
        } catch (error) {
            console.error('Error cargando materiales:', error);
        }
    };

    const cargarEquiposTicket = async () => {
        try {
            if (ticket?.materials_used && ticket.materials_used.equipos) {
                setEquiposInstalados(ticket.materials_used.equipos);
            } else if (ticket?.new_equipment_sn) {
                setEquiposInstalados([{ sn: ticket.new_equipment_sn, tipo: 'ONU' }]);
            } else if (ticket?.old_equipment_sn) {
                setEquiposInstalados([{ sn: ticket.old_equipment_sn, tipo: 'EQUIPO' }]);
            }
        } catch (error) {
            console.error('Error cargando equipos:', error);
        }
    };

    const cargarStockTecnico = async (tecnicoId) => {
        setCargandoMateriales(true);
        try {
            const response = await axios.get(`/warehouse/materiales/stock-tecnico/${tecnicoId}`);
            setStockTecnico(response.data || []);
        } catch (error) {
            console.error('Error cargando stock:', error);
        } finally {
            setCargandoMateriales(false);
        }
    };

    const agregarEquipo = () => {
        if (!nuevoEquipo.sn) {
            setError('Seleccione un equipo');
            return;
        }
        if (!nuevoEquipo.motivo) {
            setError('Ingrese el motivo del retiro');
            return;
        }
        if (equiposARetirar.some(e => e.sn === nuevoEquipo.sn)) {
            setError('Este equipo ya ha sido agregado');
            return;
        }
        setEquiposARetirar([...equiposARetirar, { ...nuevoEquipo }]);
        setNuevoEquipo({ sn: '', motivo: '' });
        setError('');
    };

    const eliminarEquipo = (index) => {
        setEquiposARetirar(equiposARetirar.filter((_, i) => i !== index));
    };

    // ✅ CAMBIO 3: agregarMaterial con parseFloat
    // Selección desde el buscador de materiales: registra el material elegido y su stock para las validaciones
    const seleccionarMaterial = (item) => {
      if (!item) {
        setNuevoMaterial(prev => ({ ...prev, material_id: '' }));
        return;
      }
      setCatalogoMateriales(prev => prev.some(m => m.id === item.material_id)
        ? prev
        : [...prev, { id: item.material_id, codigo: item.codigo, nombre: item.nombre, unidad: item.unidad }]);
      setStockTecnico(prev => [...prev.filter(s => s.material_id !== item.material_id),
        { material_id: item.material_id, cantidad: item.disponible }]);
      setNuevoMaterial(prev => ({ ...prev, material_id: item.material_id }));
    };

    const agregarMaterial = () => {
        if (!nuevoMaterial.material_id) {
            setError('Seleccione un material');
            return;
        }

        // ✅ Convertir a número al agregar
        const cantidadNum = parseFloat(nuevoMaterial.cantidad);

        if (isNaN(cantidadNum) || cantidadNum < 1) {
            setError('Ingrese una cantidad válida (mayor o igual a 1)');
            return;
        }

        const materialInfo = catalogoMateriales.find(m => m.id === nuevoMaterial.material_id);

        const nuevoMaterialObj = {
            material_id: nuevoMaterial.material_id,
            nombre: materialInfo?.nombre || 'Material',
            cantidad: cantidadNum,
            observaciones: nuevoMaterial.observaciones || ''
        };

        console.log('✅ Agregando material:', nuevoMaterialObj);
        console.log('📦 Materiales antes:', materiales);

        setMateriales(prevMateriales => {
            const nuevos = [...prevMateriales, nuevoMaterialObj];
            console.log('📦 Materiales después:', nuevos);
            return nuevos;
        });

        setNuevoMaterial({ material_id: '', cantidad: '1', observaciones: '' });  // ✅ string
        setError('');
    };

    const eliminarMaterial = (index) => {
        setMateriales(materiales.filter((_, i) => i !== index));
    };

    // ==================== handleSubmit CORREGIDO CON VIÑETA ====================
    const handleSubmit = async () => {
        if (!tecnicoId) {
            setError('Debe seleccionar un técnico');
            return;
        }
        if (equiposARetirar.length === 0) {
            setError('Debe seleccionar al menos un equipo a retirar');
            return;
        }

        if (materiales.length === 0) {
            setError('Debe seleccionar al menos un material a devolver');
            return;
        }

        if (vinetaRetirar && !ticket?.vineta && !customerVineta) {
            setError('No hay viñeta para retirar del cliente');
            return;
        }

        setLoading(true);
        setError('');

        try {
            let ubicacionData = null;
            if (usarUbicacion && ubicacion) {
                ubicacionData = {
                    latitud: ubicacion.latitud,
                    longitud: ubicacion.longitud,
                    precision: ubicacion.precision
                };
            }

            console.log('📦 MATERIALES EN EL STATE:', materiales);
            console.log('📦 MATERIALES DETALLE:', JSON.stringify(materiales, null, 2));
            console.log('📦 CANTIDAD DE MATERIALES:', materiales.length);
            console.log('🏷️ Retirar viñeta:', vinetaRetirar);
            console.log('🏷️ Viñeta actual:', ticket?.vineta || customerVineta);

            const materialesPayload = materiales.map(m => ({
                material_id: m.material_id,
                nombre: m.nombre,
                cantidad: m.cantidad,
                observaciones: m.observaciones || ''
            }));

            const equiposPayload = equiposARetirar.map(e => ({
                sn: e.sn,
                motivo: e.motivo || motivoGeneral || ticket?.description || 'Retiro de equipo'
            }));

            const payload = {
                equipos: equiposPayload,
                materiales: materialesPayload,
                motivo_retiro: motivoGeneral || "",
                fotos: fotosBase64,
                ubicacion: ubicacionData,
                vineta_nueva: undefined,
                vineta_retirar: vinetaRetirar
            };

            console.log('PAYLOAD FINAL:', JSON.stringify(payload, null, 2));

            if (payload.materiales.length === 0) {
                console.warn('⚠️ El payload tiene 0 materiales!');
            }

            const result = await ticketsAPI.closeRetiroTicket(ticket.id, payload);

            if (result.vineta_retirada) {
                alert('✅ Viñeta retirada exitosamente del cliente');
            }

            if (result.pdf_generado && result.pdf_base64) {
                setPdfBase64(result.pdf_base64);
                setTicketNumber(result.ticket || ticket.ticket_number);
                setTicketId(ticket.id);
            }

            setShowSuccess(true);
            if (onSuccess) onSuccess();

            setTimeout(() => {
                onClose();
            }, 2000);

        } catch (err) {
            console.error('Error completo:', err);
            console.error('Response:', err.response);
            setError(err.response?.data?.detail || 'Error al cerrar el ticket');
            setShowSuccess(false);
        } finally {
            setLoading(false);
        }
    };

    // Pantalla de éxito
    if (showSuccess) {
        return (
            <Dialog open={open} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ textAlign: 'center' }}>
                    <CheckIcon sx={{ fontSize: 60, color: 'success.main' }} />
                    <Typography variant="h5" color="success.main" sx={{ mt: 1 }}>
                        ¡Retiro Completado!
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ textAlign: 'center', py: 2 }}>
                        <Typography variant="body1" gutterBottom>
                            Ticket <strong>{ticketNumber || ticket?.ticket_number}</strong> cerrado exitosamente.
                        </Typography>
                        {pdfBase64 && (
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                startIcon={<DownloadIcon />}
                                onClick={handleDownloadPDF}
                                sx={{ mt: 3, mb: 2, px: 4 }}
                                fullWidth
                            >
                                📄 Descargar PDF del Retiro
                            </Button>
                        )}
                        {!pdfBase64 && (
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                                El PDF se generará automáticamente.
                            </Typography>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                    <Button variant="outlined" onClick={handleCloseDialog} size="large">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    if (!ticket) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                Completar Retiro
                <Typography variant="body2" color="text.secondary">
                    Ticket: {ticket.ticket_number} - {ticket.title}
                </Typography>
            </DialogTitle>

            <DialogContent>
                {/* FOTOS */}
                <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <PhotoIcon color="primary" />
                        Evidencia Fotográfica
                    </Typography>
                    <FotoUploader onFotosChange={setFotosBase64} maxFotos={9} />
                </Box>

                {/* UBICACIÓN */}
                <Paper sx={{ p: 2, mb: 2, bgcolor: '#f5f5f5' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                        <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LocationIcon color="primary" />
                            Ubicación del Retiro
                        </Typography>
                        <FormControlLabel
                            control={<Switch checked={usarUbicacion} onChange={(e) => setUsarUbicacion(e.target.checked)} size="small" />}
                            label="Guardar ubicación"
                        />
                    </Box>
                    {usarUbicacion && (
                        <>
                            {!ubicacion && !obteniendoUbicacion && !errorUbicacion && (
                                <Button size="small" variant="outlined" startIcon={<MyLocationIcon />} onClick={obtenerUbicacion} fullWidth>
                                    Obtener ubicación actual
                                </Button>
                            )}
                            {obteniendoUbicacion && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <CircularProgress size={20} />
                                    <Typography variant="body2">Obteniendo ubicación...</Typography>
                                </Box>
                            )}
                            {errorUbicacion && (
                                <Alert severity="warning" size="small" sx={{ mt: 1 }}>{errorUbicacion}</Alert>
                            )}
                            {ubicacion && (
                                <Alert severity="success" sx={{ mt: 1 }} icon={<MyLocationIcon />}>
                                    <Typography variant="caption" display="block">
                                        Lat: {ubicacion.latitud.toFixed(6)} | Lng: {ubicacion.longitud.toFixed(6)}
                                    </Typography>
                                    {ubicacion.precision && (
                                        <Typography variant="caption" display="block" color="text.secondary">
                                            Precisión: ±{Math.round(ubicacion.precision)}m
                                        </Typography>
                                    )}
                                </Alert>
                            )}
                        </>
                    )}
                </Paper>

                {/* ✅ SECCIÓN DE VIÑETA PARA RETIRO */}
                <Divider sx={{ my: 2 }} />
                <Typography variant="subtitle1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <VignetteIcon color="warning" />
                    Gestión de Viñeta
                </Typography>

                {(() => {
                    const vinetaActual = ticket?.vineta || customerVineta || 'Sin viñeta asignada';
                    const hayVineta = vinetaActual !== 'Sin viñeta asignada';
                    return (
                        <Alert severity="info" sx={{ mb: 2 }}>
                            <strong>🏷️ Viñeta actual:</strong> {vinetaActual}
                            {ticket?.customer_name && ` (Cliente: ${ticket.customer_name})`}
                            {hayVineta && (
                                <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 0.5 }}>
                                    {ticket?.vineta ? 'Viñeta registrada en el ticket' : 'Viñeta obtenida del cliente'}
                                </Typography>
                            )}
                        </Alert>
                    );
                })()}

                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={vinetaRetirar}
                                    onChange={(e) => {
                                        setVinetaRetirar(e.target.checked);
                                    }}
                                    color="error"
                                    disabled={!ticket?.vineta && !customerVineta}
                                />
                            }
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <DeleteIconVignette color={vinetaRetirar ? 'error' : 'disabled'} />
                                    <Typography variant="body2">
                                        Retirar viñeta del cliente (volverá a BODEGA)
                                    </Typography>
                                    {!ticket?.vineta && !customerVineta && (
                                        <Chip label="Sin viñeta" size="small" color="warning" />
                                    )}
                                </Box>
                            }
                        />
                        {!ticket?.vineta && !customerVineta && (
                            <Typography variant="caption" color="text.secondary" sx={{ ml: 7 }}>
                                No hay viñeta para retirar
                            </Typography>
                        )}
                    </Grid>
                </Grid>

                {vinetaRetirar && (ticket?.vineta || customerVineta) && (
                    <Alert severity="warning" sx={{ mt: 2, fontSize: '0.8rem' }}>
                        ⚠️ Se retirará la viñeta <strong>{ticket?.vineta || customerVineta}</strong> del cliente.
                        <br />
                        <Typography variant="caption" color="text.secondary">
                            La viñeta volverá a estado BODEGA y quedará disponible para futuras asignaciones.
                        </Typography>
                    </Alert>
                )}

                {/* Equipos Instalados */}
                <Box sx={{ mb: 3, mt: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                        Equipos Instalados
                    </Typography>
                    {equiposInstalados.length === 0 ? (
                        <Alert severity="info">No hay equipos registrados en este ticket</Alert>
                    ) : (
                        <Box>
                            {equiposInstalados.map((eq, idx) => (
                                <Chip key={idx} label={`${eq.sn} (${eq.tipo || 'ONU'})`} sx={{ mr: 1, mb: 1 }} />
                            ))}
                        </Box>
                    )}
                </Box>

                {/* Equipos a Retirar */}
                <Typography variant="h6" gutterBottom>
                    Equipos a Retirar
                </Typography>

                <Paper sx={{ p: 2, mb: 2 }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={5}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Equipo</InputLabel>
                                <Select
                                    value={nuevoEquipo.sn}
                                    onChange={(e) => setNuevoEquipo({ ...nuevoEquipo, sn: e.target.value })}
                                    label="Equipo"
                                >
                                    {equiposInstalados.map(eq => (
                                        <MenuItem key={eq.sn} value={eq.sn}>
                                            {eq.sn} ({eq.tipo || 'ONU'})
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <TextField
                                fullWidth
                                label="Motivo del Retiro"
                                size="small"
                                value={nuevoEquipo.motivo}
                                onChange={(e) => setNuevoEquipo({ ...nuevoEquipo, motivo: e.target.value })}
                                placeholder="Ej: Cliente canceló servicio, equipo dañado"
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Button fullWidth variant="contained" onClick={agregarEquipo} startIcon={<AddIcon />} disabled={!nuevoEquipo.sn || !nuevoEquipo.motivo}>
                                Agregar
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>

                {equiposARetirar.length > 0 && (
                    <List sx={{ mb: 2 }}>
                        <Divider />
                        {equiposARetirar.map((eq, idx) => (
                            <React.Fragment key={idx}>
                                <ListItem>
                                    <ListItemText primary={eq.sn} secondary={`Motivo: ${eq.motivo}`} />
                                    <ListItemSecondaryAction>
                                        <IconButton edge="end" onClick={() => eliminarEquipo(idx)} size="small" color="error">
                                            <DeleteIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <Divider />
                            </React.Fragment>
                        ))}
                    </List>
                )}

                {/* Materiales a Devolver */}
                <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                    <InventoryIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                    Materiales a Devolver
                </Typography>

                <Paper sx={{ p: 2, mb: 2 }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={5}>
                            <MaterialBuscador
                              ticketId={ticket?.id}
                              tecnicoId={tecnicoId || ticket?.assigned_technician_id}
                              modo="catalogo"
                              value={nuevoMaterial.material_id}
                              onSelect={seleccionarMaterial}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            {/* ✅ CAMBIO 2: onChange simple + onFocus select */}
                            <TextField
                                fullWidth
                                type="number"
                                label="Cantidad"
                                size="small"
                                value={nuevoMaterial.cantidad}
                                onChange={(e) => {
                                    const valor = e.target.value;
                                    if (valor === '' || /^\d*\.?\d*$/.test(valor)) {
                                        setNuevoMaterial({ ...nuevoMaterial, cantidad: valor });
                                    }
                                }}
                                onFocus={(e) => e.target.select()}
                                inputProps={{ min: 1, step: 1 }}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Observaciones"
                                size="small"
                                value={nuevoMaterial.observaciones}
                                onChange={(e) => setNuevoMaterial({ ...nuevoMaterial, observaciones: e.target.value })}
                                placeholder="Estado del material, etc."
                            />
                        </Grid>
                        <Grid item xs={12} md={1}>
                            <Button fullWidth variant="contained" onClick={agregarMaterial} startIcon={<AddIcon />} disabled={!nuevoMaterial.material_id}>
                                Agregar
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>

                {materiales.length > 0 && (
                    <List sx={{ mb: 2 }}>
                        <Divider />
                        {materiales.map((mat, idx) => (
                            <React.Fragment key={idx}>
                                <ListItem>
                                    <ListItemText
                                        primary={`${mat.nombre} x${mat.cantidad}`}
                                        secondary={mat.observaciones || 'Sin observaciones'}
                                    />
                                    <ListItemSecondaryAction>
                                        <IconButton edge="end" onClick={() => eliminarMaterial(idx)} size="small" color="error">
                                            <DeleteIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <Divider />
                            </React.Fragment>
                        ))}
                    </List>
                )}

                {/* Técnico y Motivo General */}
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Técnico que realiza el retiro *</InputLabel>
                    <Select
                        value={tecnicoId}
                        onChange={(e) => setTecnicoId(e.target.value)}
                        label="Técnico que realiza el retiro *"
                        disabled={cargandoTecnicos}
                    >
                        <MenuItem value="">Seleccione un técnico</MenuItem>
                        {tecnicos.map((tech) => (
                            <MenuItem key={tech.id} value={tech.id}>
                                {tech.full_name || tech.username} - {tech.phone || 'Sin teléfono'}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField
                    fullWidth
                    label="Motivo General (opcional)"
                    multiline
                    rows={2}
                    value={motivoGeneral}
                    onChange={(e) => setMotivoGeneral(e.target.value)}
                    placeholder="Observaciones adicionales sobre el retiro..."
                    sx={{ mb: 2 }}
                />

                {cargandoMateriales && (
                    <Box sx={{ textAlign: 'center', py: 2 }}>
                        <CircularProgress size={24} />
                        <Typography variant="caption">Cargando stock del técnico...</Typography>
                    </Box>
                )}

                {error && (
                    <Alert severity="error" sx={{ mt: 2 }}>
                        {error}
                    </Alert>
                )}

                <Alert severity="info" sx={{ mt: 2 }}>
                    <strong>Información:</strong> Al cerrar este ticket, los equipos cambiarán a estado <strong>RETIRO_PENDIENTE</strong>,
                    se devolverán los materiales al stock y quedarán bajo responsabilidad del técnico para su devolución a bodega.
                </Alert>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="warning"
                    disabled={loading || !tecnicoId || equiposARetirar.length === 0 || materiales.length === 0}
                    startIcon={loading ? <CircularProgress size={20} /> : <WarningIcon />}
                >
                    {loading ? 'Cerrando...' : 'Completar Retiro'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CloseRetiroDialog;
